import React from 'react';
import type { AfcSubmission } from '@axiom/validation';

import { Paragraph } from '../../content/Paragraph/Paragraph';
import { SmallHeader } from '../../content/SmallHeader/SmallHeader';
import { Grid } from '../../layout/Grid/Grid';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { GridRow } from '../../layout/Grid/GridRow';
import { Gutter } from '../../layout/Gutter/Gutter';
import { DateUtil } from '../../../utils/date-util';

export type SubmissionPdfDescriptionMultiTalentProps = {
  loginUrl: string;
  submission: AfcSubmission;
};
export const SubmissionPdfDescriptionMultiTalent = ({
  loginUrl,
  submission,
}: SubmissionPdfDescriptionMultiTalentProps) => {
  const displaySalesLeadContact = () => {
    if (submission.salesLead?.firstName) {
      return submission.salesLead.lastName
        ? `${submission.salesLead.firstName} ${submission.salesLead.lastName}`
        : submission.salesLead.firstName;
    }

    return 'your Axiom rep';
  };

  return (
    <Gutter horizontal="24px">
      <Grid name="SUBMISSION_DESCRIPTION">
        <GridRow gutterBottom="16px">
          <GridColumn>
            <SmallHeader>
              Instantly request an interview or engage one or more of these
              legal pros
            </SmallHeader>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <Paragraph name="BODY_COPY">
              The talent presented here are available as of{' '}
              {DateUtil.displayLongMonthDayYear(new Date())} - but skills like
              theirs are in high demand. To take action on these or any
              additional talent profiles we've selected for your engagement,{' '}
              <a href={loginUrl} data-test="LOGIN_LINK">
                sign in to your Axiom account
              </a>{' '}
              or reach out to{' '}
              <Paragraph name="HEADER_DESCRIPTION_CONTACT" as="span">
                {displaySalesLeadContact()}
              </Paragraph>{' '}
              to request access.
            </Paragraph>
          </GridColumn>
        </GridRow>
      </Grid>
    </Gutter>
  );
};
